import { layout,upload } from './reducers'

import {auth,acct,doctype,repo} from './_reducers'

import { combineReducers } from 'redux'

export default combineReducers({
    auth,acct,layout,repo,upload,doctype
})